import { Navigate } from "react-router-dom";

const AuthenticateRoute = (props) => {
  const isAuthorized = sessionStorage.getItem("accessJWT");

  return isAuthorized ? props.children : <Navigate to="/" replace />;
};

export default AuthenticateRoute;
